export const config = {
  // todo: get production and staging accounts
  accountName: __STAGING__ ? 'toasttab-com' : 'toasttab-com',
  // todo: get production and staging routers
  routerName: __STAGING__ ? 'in-app-booking' : 'in-app-booking',
};
